import { useEffect, useRef, useState } from "react";
import WebSocketManager from "../../ws/client";
import PaymentMethod from "../../components/paymentMethods";
import CreditCardPaymentModal from "../../components/CreditCardPaymentModal";
import OrderService from "../../rest/orderService";
import { MdCheckCircleOutline, MdChevronLeft, MdChevronRight, MdOutlineCancel } from 'react-icons/md';
import { BiCheckCircle } from 'react-icons/bi';
import { useNavigate } from "react-router";
import ProductGridSale from "../../components/productGridSale";
import CustomerService from "../../rest/customerService";
import MenuService from "../../rest/menuService";
import TopNavBar from "../../components/reusables/topNavBar";
import ProductService from "../../rest/productService";
import { getToday } from "../../utils/DateUtils";
import FinancialService from "../../rest/financialService";
import ComboService from "../../rest/comboService";
import ClientService from "../../rest/clientService";
import ModalPortal from "../../components/lib/modalPortal";
import OrderSummary from "../../components/reusables/orderSummary";
import NotificationsService from "../../rest/notificationService";
import CustomerGridSale from "../../components/customerGridSale";
import ReservationDatePicker from "../../components/reservationDatePicker";
import ReservationsService from "../../rest/reservationsService";
import PaymentService from "../../rest/paymentsService";
import Stepper from "../../components/lib/stepperHeader";
import { toast } from "react-toastify";


//TODO: REFACTOR THIS TO BE ABLE TO ACCEPT MULTIPLE PAYMENT METHODS
const NewOrderParent = () => {
    const [loading, setLoading] = useState(false);
    const steps = ['Cliente', 'Pedido', 'Data', 'Pagamento', 'Resumo'];
    const [customer, setCustomer] = useState('');
    const [totalSpentToday, setTotalSpentToday] = useState(0.0);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [list, setList] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [itemCount, setItemCount] = useState(0);
    const [showInsuficientCreditsMessage, setshowInsuficientCreditsMessage] = useState(false);
    const [showModalDailyLimit, setShowModalDailyLimit] = useState(false);
    const [showCardModal, setShowCardModal] = useState(false);
    const [pixPayment, setPixPayment] = useState(null);
    const [pixReservationId, setPixReservationId] = useState(null);
    const [pixConfirmed, setPixConfirmed] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const [clientInfo, setClientInfo] = useState();
    const [preferences, setPreferences] = useState();
    const [asaasEnabled, setAsaasEnabled] = useState(false);

    const [reservation, setReservation] = useState({
        reservation_id: '',
        studentId: '',
        parentId: '',
        turnId: '',
        desiredDate: '',
        itemsList: '',
        total: '',
        status: '',
        clientCode: '',
        transactions: [],
    });

    const [isOpened, setIsOpened] = useState(false);

    useEffect(() => {
        const info = JSON.parse(sessionStorage.getItem('clientInfo'));
        setClientInfo(info);
        const searchInput = getToday();

        const checkIfOpen = async () => {
            try {
                const data = await FinancialService.checkIfOpen(searchInput);
                setIsOpened(data);
            } catch (error) {
                console.error(error);
                setIsOpened(false);
            }
        };

        const getPreferences = async () => {
            const data = await ClientService.getClientAdminPreferences();
            setPreferences(data);
        }

        const getIntegration = async () => {
            const clientCode = sessionStorage.getItem('clientCode');
            const status = await PaymentService.getIntegrationStatus(clientCode);
            setAsaasEnabled(status?.asaasEnabled ?? false);
        }

        checkIfOpen();
        getPreferences();
        getIntegration();
    }, []);

    useEffect(() => {
        let count = 0;
        selectedProducts.forEach((p) => {
            count += p.quantity;
        });
        setItemCount(count);
    }, [selectedProducts]);

    useEffect(() => {
        if (!pixPayment || !pixReservationId) return;

        const clientCode = sessionStorage.getItem('clientCode');
        const topic = `/topic/clients/${clientCode}/reservations`;

        WebSocketManager.subscribe(topic, (event) => {
            const { type, payload } = event;
            if (
                (type === 'UPDATED' || type === 'CANCELED') &&
                payload?.reservationId === pixReservationId
            ) {
                if (type === 'UPDATED') setPixConfirmed(true);
                if (type === 'CANCELED') {
                    setPixPayment(null);
                    setPixReservationId(null);
                    setPixConfirmed(false);
                    toast.error("Pagamento não confirmado. Reserva cancelada.");
                }
            }
        });

        return () => WebSocketManager.unsubscribe(topic);
    }, [pixPayment, pixReservationId]);

    const parentLogin = sessionStorage.getItem("login");

    const handleStep1Value = async (value) => {
        if (!value) {
            console.info('Nenhum cliente selecionado');
            setCustomer('');
            setTotalSpentToday(0);
            return;
        }

        setCustomer(value);

        try {
            const data = await OrderService.getClientTodayTotalSpent(value.login);
            setTotalSpentToday(data);
        } catch (error) {
            console.error(error);
        }
    };

    const handleStep2Value = (value) => {
        setSelectedProducts(value)
    };

    const handleStep3Value = (values) => {
        setReservation(prev => ({
            ...prev,
            desiredDate: values.finalDate,
            turnId: values.turn.turnId,
        }));
    };

    const handleStep4Value = (transactions) => {
        setReservation(prevOrder => ({
            ...prevOrder,
            transactions: transactions
        }));
    };

    const handleChooseItem = (item, action) => {
        const updatedSelectedItems = [...selectedProducts];
        const idx = updatedSelectedItems.findIndex(i => i.id === item.id);

        if (action === "plus") {
            if (idx !== -1) {
                updatedSelectedItems[idx].quantity += 1;
            } else {
                updatedSelectedItems.push({ ...item, quantity: 1 });
            }
        } else if (action === "minus" && idx !== -1) {
            updatedSelectedItems[idx].quantity -= 1;
            if (updatedSelectedItems[idx].quantity <= 0) {
                updatedSelectedItems.splice(idx, 1);
            }
        } else if (action === "remove" && idx !== -1) {
            updatedSelectedItems.splice(idx, 1);
        }

        setSelectedProducts(updatedSelectedItems);
    };

    const calculateTotalAmount = (products) => {
        const amount = products.reduce((total, product) => {
            return total + (product.online_price || product.price) * product.quantity;
        }, 0);
        setTotalAmount(amount.toFixed(2));
    };

    const generateItemList = (products) => {
        return products.map(product => `${product.id} x${product.name} x${product.quantity} x${product.type} x${product.online_price || product.price}`).join(', ');
    };

    useEffect(() => {
        const login = sessionStorage.getItem("login");
        const name = sessionStorage.getItem("name");

        calculateTotalAmount(selectedProducts);
        setReservation(prevReservation => ({
            ...prevReservation,
            studentId: `${customer.login} / ${customer.name}`,
            parentId: `${login} / ${name}`,
            turnId: '',
            desiredDate: '',
            itemsList: generateItemList(selectedProducts),
            total: totalAmount,
            status: 'PENDING',
            clientCode: sessionStorage.getItem('clientCode'),
        }));
    }, [customer, totalAmount, selectedProducts]);

    const checkBalanceForOrder = () => {
        const totalAmountWithEmergencyValue = totalAmount - customer.emergency_value;

        if (customer.credit >= totalAmount) {
            return true;
        } else if (customer.credit === 0 && totalAmount <= customer.emergency_value) {
            return true;
        } else if (customer.credit === 0 && totalAmount > customer.emergency_value) {
            return false;
        } else if (customer.credit < 0 && totalAmount <= (customer.credit + customer.emergency_value)) {
            return true;
        } else if (customer.credit < 0 && totalAmount > (customer.credit + customer.emergency_value)) {
            return false;
        } else if (customer.credit > 0 && totalAmountWithEmergencyValue <= customer.credit) {
            return true;
        } else return customer.credit > 0 && totalAmountWithEmergencyValue <= (customer.credit + customer.emergency_value);
    };

    const updateCredits = () => {
        const newCredit = customer.credit - totalAmount;
        return Math.max(-customer.emergency_value, newCredit).toFixed(2);
    }

    async function updateClientData() {
        try {
            await CustomerService.updateStudentCredit(
                customer.login_student,
                {
                    "login_student": customer.login_student,
                    "credit": customer.credit,
                    "client_code": customer.client_code
                },
                reservation.transactions[0]);
            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    async function updateProductData() {
        try {
            for (const s of selectedProducts) {
                if (s.type === "product") {
                    await ProductService.updateProductQuantity(s.id, "REMOVE", {
                        "product_id": s.id,
                        "quantity": s.quantity,
                        "clientCode": s.client_code
                    });
                } else if (s.type === "recipe") {
                    await MenuService.updateRecipeQuantity(s.id, "REMOVE", {
                        "recipe_id": s.id,
                        "quantity": s.quantity,
                        "clientCode": s.client_code
                    });
                } else if (s.type === "combo") {
                    await ComboService.updateComboQuantity(s.id, "REMOVE", {
                        "combo_id": s.id,
                        "quantity": s.quantity,
                        "client_code": s.client_code
                    });
                }
            }

            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    async function notifyPurchase(skipNavigate = false) {
        const preferences = await ClientService.getClientAdminPreferences();
        const send = preferences?.enable_send_notifications === true;

        if (send) {
            NotificationsService.sendEmailNotificationForOrder(clientInfo, customer, reservation, 'Pedido feito pelo acesso do Cliente', 0, selectedProducts)
                .then(() => {
                    toast.success("Pedido enviado com sucesso!");
                    setLoading(false);
                    if (!skipNavigate) navigate(0);
                })
                .catch((error) => {
                    console.error(error);
                    if (error.response && error.response.status === 400) {
                        toast.success("Erro ao enviar pedido!");
                        if (!skipNavigate) navigate(0);
                    }
                });
        } else {
            toast.success("Pedido enviado com sucesso!");
            if (!skipNavigate) navigate(0);
        }
    }

    const buildPaymentMethod = () => {
        if (!reservation.transactions || reservation.transactions.length === 0) return 'Credito Foodz';
        return reservation.transactions.map(tx => tx.paymentMethod).join(', ');
    };

    const handleSubmit = async () => {
        const total = parseFloat(reservation.total)
        const totalToday = parseFloat(totalSpentToday)

        if (total + totalToday > customer.spend_limit) {
            handleDailyLimit();
            return;
        }

        const isCreditFoodz = reservation.transactions.length === 1 &&
            reservation.transactions[0].paymentMethod === 'CREDITO FOODZ';
        const isPixPayment = reservation.transactions.some(tx => tx.paymentMethod === 'PIX');
        const hasCreditCardTx = (reservation.transactions || []).some(tx => {
            const base = (tx.paymentMethod || '').split('/')[0];
            return base === 'CREDITO' || base === 'DEBITO';
        });

        if (isCreditFoodz) {
            if (checkBalanceForOrder() === true) {
                customer.credit = updateCredits();
                const payload = { reservation: { ...reservation, paymentMethod: 'CREDITO FOODZ' } };
                ReservationsService.registerReservation(payload)
                    .then(() => {
                        updateClientData().then(() => {
                            updateProductData().then((success) => {
                                if (success) notifyPurchase();
                            });
                        });
                    })
                    .catch((error) => console.error(error));
            } else {
                setshowInsuficientCreditsMessage(!showInsuficientCreditsMessage);
            }
        } else if (isPixPayment) {
            const payload = { reservation: { ...reservation, paymentMethod: 'PIX' } };
            try {
                const response = await ReservationsService.registerReservation(payload);
                setLoading(true);
                updateProductData().then((success) => {
                    if (success) notifyPurchase(true);
                });
                if (response?.payment?.qrCodeEncodedImage) {
                    setPixReservationId(response.reservation?.reservationId ?? null);
                    setPixConfirmed(false);
                    setPixPayment(response.payment);
                }
            } catch (error) {
                console.error("Erro ao salvar reserva PIX:", error);
            }
        } else if (hasCreditCardTx) {
            setShowCardModal(true);
        } else {
            const payload = { reservation: { ...reservation, paymentMethod: buildPaymentMethod() } };
            ReservationsService.registerReservation(payload)
                .then(() => {
                    setLoading(true);
                    updateProductData().then((success) => {
                        if (success) notifyPurchase();
                    });
                })
                .catch((error) => {
                    console.error("Erro ao salvar reserva:", error);
                });
        }
    };

    const handleCardPay = (cardPaymentData) => {
        setShowCardModal(false);
        const pm = buildPaymentMethod();
        const payload = {
            reservation: { ...reservation, paymentMethod: pm },
            creditCardToken: cardPaymentData.creditCardToken || null,
            creditCardData: cardPaymentData.creditCardData || null,
        };
        ReservationsService.registerReservation(payload)
            .then(() => {
                setLoading(true);
                updateProductData().then((success) => {
                    if (success) notifyPurchase();
                });
            })
            .catch((error) => {
                console.error("Erro ao salvar reserva com cartão:", error);
            });
    };

    const navigate = useNavigate();

    const handleDailyLimit = () => {
        setShowModalDailyLimit(!showModalDailyLimit)
    }

    const handleCancelClick = () => {
        setShowModalDailyLimit(!showModalDailyLimit)
    }

    const handleCancel = () => {
        OrderService.deleteCanceledOrder(reservation.order_id)
            .then(() => {
                setTimeout(() => {
                    navigate(`/clientes/detalhesCliente/${customer.login_student}`);
                }, 1000);
                toast.warn("Envio de pedido cancelado!");
            })
            .catch((error) => {
                console.error(error);
            });
    }

    const handlePrevious = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    };

    const handleNext = () => {
        const isStepValid = validateStep(currentStep);
        if (isStepValid) {
            if (currentStep <= steps.length) {
                setCurrentStep(currentStep + 1);
            }
        }
    };

    const validateStep = (step) => {
        switch (step) {
            case 1:
                return customer !== null && customer !== '';
            case 2:
                return selectedProducts.length !== 0;
            case 3:
                return reservation.desiredDate !== '' && String(reservation.turnId) !== '';
            case 4:
                return reservation.transactions.length !== 0;
            default:
                return true;
        }
    };

    const renderStepComponent = () => {
        switch (currentStep) {
            case 1:
                return <CustomerGridSale onValueChange={handleStep1Value} parentLogin={parentLogin} />;
            case 2:
                return <ProductGridSale onValueChange={handleStep2Value}
                    onChooseItem={handleChooseItem}
                    selectedItems={selectedProducts}
                    list={list}
                    setList={setList}
                    isCustomer={true} />;
            case 3:
                return <ReservationDatePicker onSelectionChange={handleStep3Value} studentLogin={customer?.login} />;
            case 4:
                return <PaymentMethod
                    totalAmount={totalAmount}
                    onTransactionChange={handleStep4Value}
                    clientId={reservation.studentId}
                    acceptedPayments={preferences.accepted_payments}
                    showCreditCard={true}
                    asaasEnabled={asaasEnabled}
                />;
            default:
                return <OrderSummary reservationDate={reservation.desiredDate} order={reservation} customer={customer} selectedProducts={selectedProducts} itemCount={itemCount} totalAmount={totalAmount} />

        }
    };

    return (
        <div className='h-full flex flex-col'>
            <TopNavBar title={"Novo Pedido"} subtitle={""} />
            <div className='mx-2 lg:mx-10 my-6 font-poppins text-custom_lighter_gray_font'>
                <div className="flex w-full h-full rounded-lg border-2 my-6 border-slate-200">
                    <div className='flex-col w-full'>
                        <div className="w-full flex items-start justify-between px-4 mt-4 gap-4">
                            <button
                                onClick={handlePrevious}
                                disabled={currentStep <= 1 || loading}
                                className={`flex items-center justify-center gap-2 font-semibold py-2 px-3 rounded-lg transition-all shrink-0 ${currentStep <= 1
                                    ? "text-gray-300 cursor-not-allowed"
                                    : "bg-gray-100 text-gray-600 hover:bg-gray-200 hover:text-custom_blue"
                                    }`}>
                                <MdChevronLeft size={24} />
                                <span className="hidden sm:inline">Voltar</span>
                            </button>

                            <div className="flex-1 min-w-0 mt-0.5">
                                <Stepper
                                    steps={steps.map(label => ({ label }))}
                                    currentStep={currentStep - 1}
                                />
                            </div>

                            {/* BOTÃO PRÓXIMO */}
                            <div className="shrink-0">
                                {currentStep < steps.length ? (
                                    <button
                                        onClick={handleNext}
                                        disabled={!validateStep(currentStep) || loading}
                                        className="bg-custom_blue hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold py-2 px-3 sm:px-6 rounded-lg shadow-md transition-all flex items-center gap-2"
                                    >
                                        <MdChevronRight size={20} />
                                    </button>
                                ) : (
                                    <button
                                        type="submit"
                                        onClick={handleSubmit}
                                        disabled={!validateStep(currentStep) || loading}
                                        className="bg-custom_green hover:bg-green-600 disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold py-2 px-3 sm:px-6 rounded-lg shadow-md transition-all flex items-center gap-2"
                                    >
                                        <MdCheckCircleOutline size={20} />
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className='mx-2 md:mx-6 animate-in fade-in slide-in-from-bottom-4 duration-500'>
                            {renderStepComponent()}
                        </div>
                    </div>

                    {showCardModal && (
                        <CreditCardPaymentModal
                            customer={customer}
                            clientCode={sessionStorage.getItem('clientCode')}
                            totalAmount={totalAmount}
                            onPay={handleCardPay}
                            onCancel={() => setShowCardModal(false)}
                        />
                    )}

                    {pixPayment && (
                        <ModalPortal>
                            <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-6">
                                <div className="rounded-lg bg-white text-center w-full max-w-sm z-50 p-8 shadow-lg">
                                    {pixConfirmed ? (
                                        <>
                                            <BiCheckCircle className="text-green-500 text-6xl mx-auto mb-4" />
                                            <h2 className="text-xl font-semibold text-green-600 mb-2">Pagamento recebido!</h2>
                                            <p className="text-sm text-gray-500 mb-6">Sua reserva está confirmada e será liberada no início do turno.</p>
                                            <button
                                                className="bg-custom_green text-white font-medium py-2 px-6 rounded-lg"
                                                onClick={() => { setPixPayment(null); setPixReservationId(null); setPixConfirmed(false); navigate(0); }}
                                            >
                                                OK
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <h2 className="text-xl font-semibold mb-4">Pagamento PIX</h2>
                                            <img
                                                src={`data:image/png;base64,${pixPayment.qrCodeEncodedImage}`}
                                                alt="QR Code PIX"
                                                className="w-64 h-64 mx-auto border-2 border-gray-300"
                                            />
                                            <p className="mt-4 text-sm text-gray-600">Ou copie o código abaixo:</p>
                                            <input
                                                type="text"
                                                readOnly
                                                value={pixPayment.qrCodePayload || ''}
                                                className="w-full mt-2 p-2 text-xs border rounded text-center"
                                            />
                                            <button
                                                className="mt-2 text-sm text-custom_blue underline"
                                                onClick={() => navigator.clipboard.writeText(pixPayment.qrCodePayload || '')}
                                            >
                                                Copiar código
                                            </button>
                                            <p className="mt-4 text-xs text-gray-400 animate-pulse">Aguardando confirmação do pagamento...</p>
                                            <div className="mt-4">
                                                <button
                                                    className="bg-custom_green text-white font-medium py-2 px-6 rounded-lg"
                                                    onClick={() => { setPixPayment(null); setPixReservationId(null); setPixConfirmed(false); navigate(0); }}
                                                >
                                                    OK
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </ModalPortal>
                    )}

                    {showInsuficientCreditsMessage && (
                        <ModalPortal>
                            <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-10" >
                                <div className="rounded-lg bg-white text-center h-1/2 w-3/4 z-50 p-12 shadow-lg">
                                    <p className="p-4 text-2xl">Não é possível finalizar a compra por falta de créditos e saldo emegência disponível.
                                        Recarregue a quantidade de créditos Foodz!</p>
                                    <p className="p-4 text-lg"> (Obs.: Ao cancelar um pedido, nenhum registro da venda
                                        ficará
                                        salvo.)</p>
                                    <div className="flex align-center justify-center p-6">
                                        <button
                                            className='flex align-center justify-center bg-custom_red w-full h-full text-white font-medium p-2 m-2 rounded-lg'
                                            onClick={handleCancel}>
                                            <MdOutlineCancel className="text-white scale-150 mx-2" />
                                            <p className="text-white font-medium leading-tight"> Cancelar Pedido</p>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </ModalPortal>
                    )}

                    {showModalDailyLimit && (
                        <ModalPortal>
                            <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-10" >
                                <div className="rounded-lg bg-white text-center h-1/2 w-3/4 z-50 p-12 shadow-lg">
                                    <p className="p-4 text-2xl">Não é possível finalizar a compra pois o cliente já
                                        atingiu o
                                        limite de gastos diários estabelecido pelo seu(s) responsável(is).</p>
                                    <div className="flex items-center justify-center p-6">
                                        <button
                                            className="bg-custom_green text-white font-medium p-3 ml-2 rounded-lg"
                                            onClick={handleCancelClick}
                                        >
                                            <p className="text-white font-medium"> OK </p>
                                            <BiCheckCircle className="scale-150" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </ModalPortal>
                    )}
                </div>
            </div>
        </div >
    )
}

export default NewOrderParent